import { render, staticRenderFns } from "./chatMessages.vue?vue&type=template&id=427b2624&scoped=true"
import script from "./chatMessages.vue?vue&type=script&lang=js"
export * from "./chatMessages.vue?vue&type=script&lang=js"
import style0 from "./chatMessages.vue?vue&type=style&index=0&id=427b2624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427b2624",
  null
  
)

export default component.exports